import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { App } from './App';
import theme from './theme';
import { ThemeProvider } from '@emotion/react';
import { SnackbarProvider } from './hooks/snackbar.hook';

/**
 * Mise en place du router qui va englober le projet
 * Appel à la constante APP qui va contenir toutes les routes
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ThemeProvider theme={theme}>
        <SnackbarProvider>
            <RouterProvider router={App} />
        </SnackbarProvider>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
